class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.updateCart();

    //this.querySelector('[data-toogle-swiper]').addEventListener('click', this.swiperEvent.bind(this));
    this.products_items = this.querySelectorAll(".swiper-slide");
    this.products_items.forEach((item) => {
      var product = item;
      var delay = item.getAttribute("data-anim-delay");
      setTimeout(function () {
        product.classList.add("product-card-anim");
      }, delay);
    });
  }

  swiperEvent(event) {
    console.log(event.target.closest(".products-list-v2__wrapper").classList);
    if (
      event.target
        .closest(".products-list-v2__wrapper")
        .classList.contains("products-list-v2__wrapper--inactif")
    ) {
      event.target
        .closest(".products-list-v2__wrapper")
        .classList.remove("products-list-v2__wrapper--inactif");
      this.displayProductsAnim();
    } else {
      event.target
        .closest(".products-list-v2__wrapper")
        .classList.add("products-list-v2__wrapper--inactif");
      this.removeProductsAnim();
    }
  }

  displayProductsAnim() {
    this.products_items.forEach((item) => {
      var product = item;
      var delay = item.getAttribute("data-anim-delay");
      setTimeout(function () {
        product.classList.add("product-card-anim");
      }, delay);
    });
  }

  removeProductsAnim() {
    this.products_items.forEach((item) => {
      var product = item;
      product.classList.remove("product-card-anim");
    });
  }

  updateCart() {
    fetch("/cart.js")
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          alert(
            "Error : Refresh cart has a problem. If you see this error please contact us."
          );
        }
      })
      .then((response) => {
        console.log(response);

        var properties_value = null;
        var product_handle = document
          .querySelector("[data-product-handle]")
          .getAttribute("data-product-handle");

        console.log(product_handle);

        if (
          "attributes" in response &&
          "_recently_viewed" in response.attributes
        ) {
          properties_value = response.attributes["_recently_viewed"];
        }

        console.log(properties_value);

        if (properties_value != null) {
          var properties_value_split = properties_value.split(",");
          console.log(properties_value_split);
          if (!(properties_value_split.indexOf(product_handle) > -1)) {
            if (properties_value_split.length == 10) {
              properties_value_split.splice(0, 1);
            }
            properties_value_split.push(product_handle);
            properties_value = properties_value_split.join(",");
          }
        } else {
          properties_value = product_handle;
        }

        console.log(properties_value);

        let formData = {
          attributes: {
            _recently_viewed: properties_value,
          },
        };
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              alert(
                "Error : Refresh cart has a problem. If you see this error please contact us."
              );
            }
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      })
      .catch((error) => {
        console.log("Get cart recently_viewed error : " + error);
      });
  }
}

customElements.define("recently-viewed", ProductRecentlyViewed);
